module.exports = __webpack_public_path__ + "img/por-ano.78072a4d.png";